import React from 'react';
import hoistNonReactStatic from 'hoist-non-react-statics';
import { flatten } from 'lodash';

import Preview from  './Preview';
import extensions from 'constants/extensions'


export default (WrappedComponent) => {
  class withPreview extends React.Component {
    state = {
      showPreview: false
    };

    canPreview = (ext) => {
      return flatten(Object.values(extensions.previewable)).includes(ext);
    };

    showPreview = ({ next, back } = {}) => {
      this.setState({ showPreview: true, next, back });
    };

    hidePreview = () => {
      this.setState({ showPreview: false });
    };

    render() {
      return (
        <div
        >
          <WrappedComponent {...this.props} showPreview={this.showPreview} canPreview={this.canPreview} />
          {
            this.state.showPreview &&
            <Preview onHide={this.hidePreview} previewable={this.state.previewable} next={this.state.next} back={this.state.back}/>
          }
        </div>
      )
    }
  }

  hoistNonReactStatic(withPreview, WrappedComponent);

  return withPreview;
}